import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export type UserType =
  | 'C-ADMIN'
  | 'C-USER'
  | 'DP-ADMIN'
  | 'DP-USER'
  | 'SP-ADMIN'
  | 'SP-TECH'
  | 'SP-OPS';

export interface ExchangeState {
  selectedAccountId?: string;
  isAuthenticated: boolean;
  accessToken?: string | null;
  userType: UserType | null;
  orgId?: string | null;
}

const initialState: ExchangeState = {
  selectedAccountId: undefined,
  isAuthenticated: false,
  accessToken: null,
  userType: null,
  orgId: null
};

const exchangeSlice = createSlice({
  name: 'exchange',
  initialState,
  reducers: {
    setSelectedAccount: (state: ExchangeState, action: PayloadAction<string | undefined>) => {
      state.selectedAccountId = action.payload;
    },
    setAccessToken: (state: ExchangeState, action: PayloadAction<string | null>) => {
      state.accessToken = action.payload;
      state.isAuthenticated = Boolean(action.payload);
    },
    setUserType: (state: ExchangeState, action: PayloadAction<UserType | null>) => {
      state.userType = action.payload;
    },
    setOrgId: (state: ExchangeState, action: PayloadAction<string | null>) => {
      state.orgId = action.payload;
    },
    login: (state: ExchangeState) => {
      state.isAuthenticated = Boolean(state.accessToken);
    },
    logout: () => initialState
  }
});

export const { setSelectedAccount, setAccessToken, setUserType, login, logout, setOrgId } =
  exchangeSlice.actions;
export default exchangeSlice.reducer;
